import { v4 as uuid } from 'uuid';

export function setItemInList(list = [], index, item) {
  return [...list.slice(0, index), item, ...list.slice(index + 1)];
}

export function generateId() {
  return uuid();
}
